import React, { createContext, useCallback, useContext, useEffect, useState } from "react"
import { CommandPalette } from "src/features/search/components/CommandPalette"

const SearchContext = createContext(null)

// Hosts the global command-palette state, the ⌘K / Ctrl+K hotkey, and renders
// the palette once for the whole app. Must live inside the router (the palette
// navigates) and the auth provider (search is for signed-in users).
export function SearchProvider({ children }) {
  const [open, setOpen] = useState(false)

  const openSearch = useCallback(() => setOpen(true), [])

  useEffect(() => {
    function onKeyDown(e) {
      const isCmdK = (e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")
      if (isCmdK) {
        e.preventDefault()
        setOpen((v) => !v)
      }
    }
    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [])

  return (
    <SearchContext.Provider value={{ open, setOpen, openSearch }}>
      {children}
      <CommandPalette open={open} onOpenChange={setOpen} />
    </SearchContext.Provider>
  )
}

export function useSearch() {
  const ctx = useContext(SearchContext)
  if (!ctx) throw new Error("useSearch must be used within a SearchProvider")
  return ctx
}
